import { render, staticRenderFns } from "./customerNew.vue?vue&type=template&id=5eb567c9&"
import script from "./customerNew.vue?vue&type=script&lang=js&"
export * from "./customerNew.vue?vue&type=script&lang=js&"
import style0 from "./customerNew.vue?vue&type=style&index=0&id=5eb567c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports